// Server-Sent Events (SSE) クライアント
import { getApiBaseUrl } from './api-client';

/**
 * SSE接続を開始
 */
export function createSSEConnection(
  sessionId: string,
  onMessage: (event: { type: string; data?: any }) => void,
  onError?: (error: Event) => void
): EventSource {
  const apiBaseUrl = getApiBaseUrl();
  const url = `${apiBaseUrl}/api/sse/generation-stopped/${sessionId}`;

  const eventSource = new EventSource(url);

  eventSource.onmessage = (event) => {
    try {
      const data = JSON.parse(event.data);
      onMessage(data);
    } catch (error) {
      console.error('Failed to parse SSE message:', error);
    }
  };

  eventSource.onerror = (error) => {
    // Cloudflare WorkersではSSEが不安定なため、エラーを警告として扱う
    // ポーリングがフォールバックとして動作する
    console.warn('[SSE] Connection error (falling back to polling):', error);
    // EventSourceのreadyStateを確認
    if (eventSource.readyState === EventSource.CLOSED) {
      console.warn('[SSE] Connection closed. Polling will be used as fallback.');
    }
    if (onError) {
      onError(error);
    }
  };
  
  // 接続が開かれたことをログに記録
  eventSource.onopen = () => {
    console.log('[SSE] Connection opened for session:', sessionId);
  };

  return eventSource;
}

/**
 * 生成完了イベントをリッスン
 */
export function listenForGenerationStopped(
  sessionId: string,
  onComplete: () => void
): EventSource {
  return createSSEConnection(
    sessionId,
    (event) => {
      if (event.type === 'generation-stopped') {
        onComplete();
      }
    }
  );
}

